<div class="container-fluid">
    <div class="content">


        <div>

            <app-transportation-breadcrumb *ngIf="!adddriver && !isEditing" s_breadcrumb="Drivers">
            </app-transportation-breadcrumb>
            <app-transportation-breadcrumb *ngIf="adddriver || isEditing" s_breadcrumb="Drivers"
                [t_breadcrumb]=" isEditing ? 'Edit' : 'New'" (emit)="cancelFunction()">
            </app-transportation-breadcrumb>



            <!--  (emit1)="cancels(2)"  -->
            <div *ngIf="!adddriver && !isEditing">

                <div class="d-flex flex-wrap">
                    <div class="showbtn me-auto  mb-3">
                        <button class="btn btn-custom" (click)="new()">
                            <i class="fa fa-plus me-1"></i> New
                        </button>
                    </div>
                </div>
                <div class=" w-100 d-flex flex-wrap me-auto ">

                    <div class="input-group me-2 mb-2" style="width: 300px !important;">
                        <input class="form-control" type="text" placeholder="&#xf002; Search" aria-label="Search"
                            [(ngModel)]="searchText" style="font-family: FontAwesome,Ubuntu;">
                    </div>
                    <div class="dropdown mb-2 me-2">
                        <button type="button" class="btn btn-custom" id="dropdownMenuButton1" data-bs-toggle="dropdown"
                            aria-expanded="false" matTooltip="Page Size">
                            <mat-icon>filter_list</mat-icon>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                                <div c style="text-align: center;">Page size</div>
                            </li>
                            <li>
                                <hr class="dropdown-divider">
                            </li>
                            <li class="dropdown-item" *ngFor="let page of pg">
                                <input type="radio" name="pg-count" value="{{page.count}}"
                                    (change)="changePageCount($event)" id="pg{{page.name}}" class="p-1"
                                    [checked]="page.count==itemPerPage">
                                <label for="pg{{page.name}}" class="col-10 p-1">
                                    {{page.name}}
                                </label>
                            </li>
                        </ul>
                    </div>

                    <!-- me-2 -->
                    <div class="me-2 mb-2 ">
                        <button class="btn btn-custom" (click)="refreshgetData()" matTooltip="Refresh">
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </div>

                    <div class="line mb-2 "></div>
                    <div class="mb-2">
                        <button type="button" class="btn btn-custom" (click)="downloadSheet()"
                            matTooltip="Export Drivers">
                            <img class="excel-icon" src="../../../assets/images/excel.png">Export
                        </button>

                    </div>
                    <div class="line mb-2 "></div>
                    <div class="d-flex align-items-center me-auto mb-2 ">
                        <span class="total-count-text ">Total:&nbsp;</span> <span
                            class="total-count-num ">{{driverList.length}}</span>
                    </div>

                    <div>

                    </div>
                </div>


                <div>
                    <div class="table-responsive" matSort (matSortChange)="sortData($event)">
                        <table class="table table-responsive table-borderless">
                            <thead class="table-header">
                                <tr>
                                    <td scope="col" class="col-lg-3 col-md-3" mat-sort-header="drivername">Driver Name
                                    </td>
                                    <td scope="col" class="col-lg-4 col-md-4" mat-sort-header="driverphone">Driver Phone
                                    </td>
                                    
                                    <td scope="col" class="d-flex justify-content-end">Action</td>
                                </tr>
                            </thead>
                            <tbody *ngIf="gettingData">
                                <tr>
                                    <td colspan="3" class="nodata">
                                        <div class="spinner-border" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody *ngIf="gettingData== false">
                                <tr *ngIf="driverList.length == 0">
                                    <td colspan="3" class="nodata">Empty</td>
                                </tr>
                                <tr *ngFor="let item of driverList | filter : searchText:'driver'">
                                    
                                    <td class="td-data" (click)="vehicleEdit(item)" style="cursor: pointer;">
                                        <span [title]="item.name">{{item.name}}</span>
                                    </td>
                                    <td class="td-data" (click)="vehicleEdit(item)" style="cursor: pointer;">
                                        <span [title]="item.mobile">{{item.mobile}}</span>
                                    </td>
                                    
                                    <td class="d-flex justify-content-end">
                                        <button matTooltip="Edit" (click)="vehicleEdit(item)"
                                            class="btn btn-outline-primary">
                                            <i class='fa fa-edit'></i>
                                        </button>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div *ngIf="adddriver || isEditing">

                <div>
                    <div class="close-save-button mb-3">
                        <button type="button" class="btn btn-custom me-2" (click)="cancelFunction()"
                            *ngIf="!saveLoading">
                            Cancel
                        </button>
                        <app-button-loader (click)="submitVehicle()" [button_text]="'Save'"
                            [load_button_text]="'Saving'" [isLoading]="saveLoading">
                        </app-button-loader>
                    </div>
                </div>


                <div class="card card-body my-card mb-3">
                    <div class="row">
                        <div class="mb-3 col-md-6">
                            <label for="drivername" class="form-label">Driver Name </label>
                            <input type="text" class="form-control" id="drivername" name="drivername"
                                [(ngModel)]="carForm.drivername" #dname="ngModel"
                                [ngClass]="{'is-invalid': carFormSave && dname.invalid}" required>

                            <div class="invalid-feedback"
                                *ngIf="dname.invalid || (dname.dirty || dname.touched) && carFormSave">
                                <div *ngIf="dname.errors?.required">
                                    {{allinoneService.input_err_msg}}
                                </div>
                            </div>

                        </div>
                        <div class="mb-3 col-md-6">
                            <label for="driverphone" class="form-label">Driver Phone </label>
                            <input type="text" class="form-control" id="driverphone" name="driverphone"
                                [(ngModel)]="carForm.driverphone" #dphone="ngModel"
                                [ngClass]="{'is-invalid': carFormSave && dphone.invalid}" required>

                            <div class="invalid-feedback"
                                *ngIf="dphone.invalid || (dphone.dirty || dphone.touched) && carFormSave">
                                <div *ngIf="dphone.errors?.required">
                                    {{allinoneService.input_err_msg}}
                                </div>
                            </div>

                        </div> 
                    </div>
                    
                </div>

            </div>
        </div>
    </div>
</div>